// extracted by mini-css-extract-plugin
module.exports = {"modalContainer":"LegalDisclaimers_modalContainer__rnTZM","modalBody":"LegalDisclaimers_modalBody__PGEpf"};